import React from "react";
import "./EidBanner.css";

const EidBanner = () => {
  return (
    <div className="eid-banner-container">
      <p className="eid-banner-tag">New Release</p>
      <h2 className="eid-banner-title">Eid Collection</h2>
      <p className="eid-banner-description">
        A curated selection of floral arrangements crafted to celebrate the
        season. Each piece is thoughtfully designed to bring elegance and warmth
        to your Eid table, home, and gifting.
      </p>
    </div>
  );
};

export default EidBanner;
